import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import { transformIntoQueryParamString } from '@old/utils/service';

type RestoreQuery = {
  query: string;
};

export async function RestoreSilobagService({ query: rawQuery }: RestoreQuery) {
  const query = transformIntoQueryParamString(rawQuery);

  const { response, data } = await BACKEND.post(ENDPOINT.SILOBAGS_RESTORE, { query });

  return {
    response,
    summary: data,
  };
}
